export enum Area {
  Primary = 'primary',
  Staging = 'staging',
}
